module.exports = __webpack_public_path__ + "img/grey_curve_top.ba405004.png";